export default __webpack_public_path__ + "static/media/Ballroll_00266.287a441b.png";